// extracted by mini-css-extract-plugin
export var check = "styles-module--check--2c013";
export var list = "styles-module--list--c6fb6";